<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    let style = document.createElement('link');
    style.type = "text/css";
    style.rel = "stylesheet";
    style.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&family=Lakki+Reddy&family=Lobster&family=Lobster+Two&family=Parisienne&family=Tangerine&display=swap';
    document.head.appendChild(style);
  }
}
</script>

<style lang="scss">
//@import url('https://fonts.googleapis.com/css2?family=Shizuru&family=Dancing+Script&display=swap');
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  // Import Main styles for this application
  @import 'src/assets/scss/style';
</style>
